export const _API_ = process.env.REACT_APP_API_URL;// 'https://configpro.exideprod.com';
export const _BASE_URL_ = process.env.REACT_APP_BASE_URL;// 'https://configpro.exideprod.com';